export default __webpack_public_path__ + "static/media/MarketplaceMobile.171f4c84.svg";